import { useEffect, useState } from 'react';
import { getGiftCards } from '../../../auth/_requests';
import type { GiftBitBrand } from '../../../helpers/utils/types';

export const useWalletGiftCards = (opts: {
  token?: string;
  search: string;
  page?: number;
  limit?: number;
  debounceMs?: number;
}) => {
  const { token, search, page = 1, limit = 10, debounceMs = 350 } = opts;
  const [cards, setCards] = useState<GiftBitBrand[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;

    const timeoutId = window.setTimeout(async () => {
      setLoading(true);
      try {
        const response = await getGiftCards(token, page, limit, search);
        setCards(response?.data ?? []);
      } catch (error) {
        console.error('Error fetching wallet gift cards:', error);
        setCards([]);
      } finally {
        setLoading(false);
      }
    }, debounceMs);

    return () => window.clearTimeout(timeoutId);
  }, [token, search, page, limit, debounceMs]);

  return { cards, loading };
};
